import { render, staticRenderFns } from "./PhysicalProject.vue?vue&type=template&id=377f36f0&scoped=true"
import script from "./PhysicalProject.vue?vue&type=script&lang=js"
export * from "./PhysicalProject.vue?vue&type=script&lang=js"
import style0 from "./PhysicalProject.vue?vue&type=style&index=0&id=377f36f0&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f36f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377f36f0')) {
      api.createRecord('377f36f0', component.options)
    } else {
      api.reload('377f36f0', component.options)
    }
    module.hot.accept("./PhysicalProject.vue?vue&type=template&id=377f36f0&scoped=true", function () {
      api.rerender('377f36f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/physicalProject/PhysicalProject.vue"
export default component.exports